import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PromoItemListPage } from '@/features/promotion/pages/PromoItemListPage';
import { promoItemSearchSchema } from '@/features/promotion/types/promotion.types';

export const Route = createFileRoute('/_auth/promotion/items')({
  validateSearch: promoItemSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="Promotional Item List">
      <Suspense fallback={<PageLoader />}>
        <PromoItemListPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
